import { Gizmo } from '../../../gizmos';
import { rootGizmoDataV2ToV3 } from '../../../gizmos/utils';
import {
  IGizmo,
  IGizmoData,
  IIndex,
  IIndexColumn,
  IRealmFilledForm,
  IRootGizmoData,
} from '../../../types';
import { gnov } from '../../../utils';

interface IParams {
  data?: IGizmoData[];
  includeRegisters?: boolean;
  context: {
    gizmo: Gizmo;
    config?: IGizmo;
  };
}

/**
 * Get annex forms index from the database
 *
 * @param {IGizmoData[]} data annex form gizmo data
 * @param {boolean} includeRegisters whether to include the registers or not on the index returned
 * @returns
 */
async function getAnnexFormsIndex({
  data,
  includeRegisters,
  context,
}: IParams): Promise<undefined | IIndex> {
  const { gizmo } = context;
  const config = gizmo.getConfig();
  const columns: IIndexColumn[] = [];

  if (config.ops?.annexForm?.columns) {
    const { columns: gizmoColumns } = config.ops.annexForm;

    for (const gColumn of gizmoColumns) {
      columns.push({
        fid: gColumn.f_id,
        label: gColumn.title,
      });
    }

    const operationsColumn: IIndexColumn = {
      fid: 'c111',
      type: 'operations',
      label: 'Operations',
      operations: [
        {
          label: 'Editar',
          type: 'register.edit',
        },
        {
          label: 'Eliminar',
          type: 'register.delete',
        },
      ],
    };
    columns.push(operationsColumn);

    let rows: any[] = data || [];
    const childRegisters: IRootGizmoData[] = [];

    if (data) {
      const database = gizmo.getDao()?.getDatabase();

      if (database) {
        rows = [];

        for (const d of data) {
          if (d.afd?.filledFormId && d.afd.formId) {
            try {
              const filledForm: IRealmFilledForm = await database.get({
                type: 'filledForms',
                fid: d.afd.filledFormId,
              });

              if (filledForm.gizmoData.answers) {
                const cols: any = [];
                d.fid = filledForm.gizmoData.fid;

                for (const column of columns) {
                  if (column.fid) {
                    const value = gnov(
                      filledForm.gizmoData.answers,
                      `${column.fid}.0.value`
                    );

                    if (value !== undefined) {
                      cols.push({
                        f_id: column.fid,
                        value: value.toString(),
                      });
                    }
                  }
                }

                // We're going to clone it because we don't want to modify the original
                // const dd = clone(d);
                const dd = d;
                if (dd.afd) {
                  dd.afd.columns = cols;
                }

                rows.push(dd);

                if (includeRegisters) {
                  const register = rootGizmoDataV2ToV3({
                    data: filledForm.gizmoData,
                  });

                  childRegisters.push(register);
                }
              }
            } catch (e) {}
          }
        }
      }
    }

    const index: IIndex = {
      fid: 'index',
      pagination: {
        page: 1,
        pageSize: 10,
        total: data?.length || 0,
      },
      columns,
      rows,
    };

    if (includeRegisters) {
      index.registers = childRegisters;
    }

    return index;
  }

  return undefined;
}

export default getAnnexFormsIndex;
